import { reduxForm, Field } from 'redux-form';
import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { RouteComponentProps, browserHistory } from 'react-router';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { ISubscriptionPlan } from 'models/subscriptionplans';
import {
	BookingInputField,
	BookingSelectMenu,
	BookingSwitchField,
	BookingTextareaField,
} from 'components/FormControls';
import { isNumber, required, requiredNumber } from 'helpers/validationattributes';
import {
	getSubscriptionPlans,
	postSubscriptionPlan,
	putSubscriptionPlan,
} from 'redux/modules/subscriptionplans/subscriptionplans';
import { ErrorSummary, LoadingOverlayWrapper } from 'components';
import renderIcon from 'helpers/renderIcon';
import { getCountryDomainValues, getCurrencyDomainValues } from 'redux/modules/domainvalues';
import { parseFields } from '../helpers';

require('./style.scss');

interface IOwnProps extends RouteComponentProps<IParams, {}> {}
interface IParams {
	id?: string;
}

interface IProps
	extends InjectedFormProps,
		IOwnProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {}

interface INewSubscriptionPlanForm {
	name: string;
	description?: string;
	freeSmss: string;
	freeEmails: string;
	isBundlesEnabled: boolean;
	currencyKey: string;
	countryKey?: string;
	smsPrice?: string;
}

const mapStateToProps = (state: IStore, ownProps: IOwnProps) => {
	let currentFormValues: INewSubscriptionPlanForm;
	if (state.form[c.FORM_NAME_NEW_SUBSCRIPTION_PLAN] && state.form[c.FORM_NAME_NEW_SUBSCRIPTION_PLAN].values) {
		currentFormValues = state.form[c.FORM_NAME_NEW_SUBSCRIPTION_PLAN].values;
	}

	return {
		currentFormValues,
		subscriptionPlansReducer: state.subscriptionPlansReducer,
		domainValues: state.domainValues,
		initialValues: ownProps.params?.id
			? state.subscriptionPlansReducer?.plans?.find((plan) => plan.id == ownProps.params?.id)
			: {},
	};
};

const mapDispatchToProps = (dispatch) => ({
	putSubscriptionPlan: (plan: ISubscriptionPlan) =>
		dispatch(putSubscriptionPlan(plan)).then((res) => {
			if (!res?.error) {
				browserHistory.push('/admin/subscriptionplans');
			}
		}),
	addSubscriptionPlan: (plan: ISubscriptionPlan) =>
		dispatch(postSubscriptionPlan(plan)).then((res) => {
			if (!res?.error) {
				browserHistory.push('/admin/subscriptionplans');
			}
		}),
	getSubscriptionPlans: () => dispatch(getSubscriptionPlans()),
	getCountryDomainValues: () => dispatch(getCountryDomainValues()),
	getCurrencyDomainValues: () => dispatch(getCurrencyDomainValues()),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminNewSubscriptionPlanForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount(): void {
		if (this.props.subscriptionPlansReducer?.plans == null) {
			this.props.getSubscriptionPlans();
		}

		if (!this.props.domainValues?.countries && !this.props.domainValues?.errorCountries) {
			this.props.getCountryDomainValues();
		}
		if (!this.props.domainValues?.currencies && !this.props.domainValues?.errorCurrencies) {
			this.props.getCurrencyDomainValues();
		}
	}

	onSubmit(form: INewSubscriptionPlanForm) {
		const addFnc = this.props.params.id ? this.props.putSubscriptionPlan : this.props.addSubscriptionPlan;

		addFnc(
			parseFields(form, [
				['freeSmss', 'int'],
				['freeEmails', 'int'],
				['currencyKey', 'int'],
				['countryKey', 'int'],
				['smsPrice', 'double'],
			]),
		);
	}

	public render() {
		const { subscriptionPlansReducer, handleSubmit, t } = this.props;

		return (
			<div className="container newSubscriptionPlan">
				<LoadingOverlayWrapper
					className="container"
					active={
						this.props.domainValues.isFetchingCountries ||
						this.props.domainValues.isFetchingCurrencies ||
						this.props.subscriptionPlansReducer.isFetching
					}
					spinner={true}
					text={t('BSPortal_Common_Loading')}
				>
					<form onSubmit={handleSubmit(this.onSubmit)}>
						<div className="row justify-content-center">
							<div className="col-lg-6 col-12">
								<h1>
									{renderIcon('arrow_left', 18, 18, 'newSubscriptionPlan__back', () => {
										browserHistory.push('/admin/subscriptionplans');
									})}{' '}
									{t('Admin_Breadcrumb_NewSubscriptionPlan')}
								</h1>
								<Field
									name="name"
									component={BookingInputField}
									clasName="noMarginTop"
									placeholder={''}
									information={t('Admin_NewSubscriptionPlan_Name')}
									validate={[required]}
								/>
								<Field
									name="description"
									component={BookingTextareaField}
									information={t(`Admin_NewSubscriptionPlan_Description`)}
								/>
								<Field
									name="freeSmss"
									component={BookingInputField}
									placeholder={''}
									information={t('Admin_NewSubscriptionPlan_FreeSmss')}
									validate={[requiredNumber, isNumber]}
								/>
								<Field
									name="freeEmails"
									component={BookingInputField}
									placeholder={''}
									information={t('Admin_NewSubscriptionPlan_FreeEmails')}
									validate={[requiredNumber, isNumber]}
								/>
								<Field
									name={`countryKey`}
									component={BookingSelectMenu}
									items={
										this.props.domainValues?.countries?.map((country) => ({
											key: country.key,
											value: t(`DV_Countries_${country.key}`),
										})) || []
									}
									label={t('Admin_NewSubscriptionPlan_Country')}
									information={t('Admin_NewSubscriptionPlan_Country')}
								/>
							</div>
						</div>
						<div className="row justify-content-center align-items-center">
							<div className="col-lg-4 col-10">
								<Field
									name="smsPrice"
									component={BookingInputField}
									placeholder={''}
									information={t('Admin_NewSubscriptionPlan_SmsPrice')}
									validate={[required, isNumber]}
								/>
							</div>
							<div className="col-2">
								<Field
									name={`currencyKey`}
									component={BookingSelectMenu}
									items={
										this.props.domainValues?.currencies?.map((currency) => ({
											key: currency.key,
											value: t(`DV_Currencies_${currency.key}`),
										})) || []
									}
									isRequired={true}
									label={t('Shop_ManageShop_General_Label_Currency')}
									information={t('Shop_ManageShop_General_Label_Currency')}
									validate={[required]}
								/>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-6 col-12">
								<Field
									name="isBundlesEnabled"
									component={BookingSwitchField}
									label={t('Admin_NewSubscriptionPlan_IsBundlesEnabled')}
								/>
								<ErrorSummary message={subscriptionPlansReducer.message} error={subscriptionPlansReducer.error} />

								<button type="submit" className="btnPrimary bsPortalBtn bsPortalBtnLarge">
									{t('BSPortal_Common_Save')}
								</button>
							</div>
						</div>
					</form>
				</LoadingOverlayWrapper>
			</div>
		);
	}
}

let AdminNewSubscriptionPlan = reduxForm({
	form: c.FORM_NAME_NEW_SUBSCRIPTION_PLAN,
	enableReinitialize: true,
})(AdminNewSubscriptionPlanForm);

AdminNewSubscriptionPlan = connect(mapStateToProps, mapDispatchToProps)(AdminNewSubscriptionPlan);

export { AdminNewSubscriptionPlan };
